export const colors = {
  lightBlue: '#4782da',
  lightGrey: 'rgba(0, 0, 0, 0.15)',
  hoveredButtonGrey: 'rgba(0, 0, 0, 0.04)',
  blueBackgroundColor: '#f7f9fc',
  red: 'red',
};
